import posthog from 'posthog-js';

/**
 * Initialise PostHog côté client (frontend)
 * @returns {PostHog} Instance PostHog
 */
export function initPostHog() {
  if (typeof window === 'undefined') return posthog;
  if (window._posthog_initialized) return posthog;

  const apiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
  const host = import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://eu.i.posthog.com';

  if (!apiKey) {
    console.warn('⚠️  PostHog non configuré (VITE_POSTHOG_KEY manquant) - Mode désactivé');
    window._posthog_initialized = true; // Empêcher les tentatives répétées
    return posthog;
  }

  // PostHog temporairement désactivé - À réactiver après configuration
  console.warn('⚠️  PostHog temporairement désactivé');
  window._posthog_initialized = true;
  return posthog;

  /* DÉCOMMENTEZ POUR RÉACTIVER POSTHOG
  try {
    posthog.init(apiKey, {
      api_host: host,
      autocapture: false, // Désactivé - on préfère les événements nommés
      disable_session_recording: true, // Désactivé par défaut - activé après consentement
      capture_pageview: true, // Capture automatique des pages vues
      persistence: 'localStorage',
      defaults: '2025-05-24', // Version des defaults PostHog
      loaded: (ph) => {
        console.log('✅ PostHog initialisé (frontend)');
      }
    });

    window._posthog_initialized = true;
  } catch (error) {
    console.error('❌ Erreur initialisation PostHog:', error);
  }

  return posthog;
  */
}

/**
 * Active le tracking après consentement utilisateur
 */
export function enableTracking() {
  posthog.opt_in_capturing();
  console.log('✅ PostHog tracking activé');
}

/**
 * Active l'enregistrement de session après consentement
 */
export function enableSessionRecording() {
  posthog.startSessionRecording();
  console.log('✅ PostHog session recording activé');
}

/**
 * Désactive le tracking
 */
export function disableTracking() {
  posthog.opt_out_capturing();
  console.log('⛔ PostHog tracking désactivé');
}

/**
 * Capture un événement personnalisé
 * @param {string} eventName - Nom de l'événement
 * @param {object} properties - Propriétés de l'événement
 */
export function captureEvent(eventName, properties = {}) {
  // PostHog désactivé - Ne rien faire
  return;

  /* DÉCOMMENTEZ POUR RÉACTIVER
  try {
    posthog.capture(eventName, {
      ...properties,
      timestamp: new Date().toISOString()
    });
    console.log(`[PostHog] Event: ${eventName}`, properties);
  } catch (error) {
    console.error(`[PostHog] Erreur capture event ${eventName}:`, error);
  }
  */
}

/**
 * Identifie l'utilisateur connecté
 * @param {string} userId - ID utilisateur
 * @param {object} properties - Propriétés utilisateur
 */
export function identifyUser(userId, properties = {}) {
  // PostHog désactivé - Ne rien faire
  return;

  /* DÉCOMMENTEZ POUR RÉACTIVER
  try {
    posthog.identify(userId, properties);
    console.log(`[PostHog] User identified: ${userId}`);
  } catch (error) {
    console.error('[PostHog] Erreur identify:', error);
  }
  */
}

/**
 * Réinitialise l'identification (déconnexion)
 */
export function resetUser() {
  // PostHog désactivé - Ne rien faire
  return;

  /* DÉCOMMENTEZ POUR RÉACTIVER
  posthog.reset();
  console.log('[PostHog] User reset');
  */
}

/**
 * Récupère la valeur d'un feature flag
 * @param {string} flagKey - Nom du flag
 * @returns {boolean|string|undefined}
 */
export function getFeatureFlag(flagKey) {
  try {
    return posthog.getFeatureFlag(flagKey);
  } catch (error) {
    console.error(`[PostHog] Erreur get feature flag ${flagKey}:`, error);
    return undefined;
  }
}

/**
 * Vérifie si un feature flag est activé
 * @param {string} flagKey - Nom du flag
 * @returns {boolean}
 */
export function isFeatureEnabled(flagKey) {
  try {
    return posthog.isFeatureEnabled(flagKey);
  } catch (error) {
    console.error(`[PostHog] Erreur is feature enabled ${flagKey}:`, error);
    return false;
  }
}

export default posthog;
